import styled from "styled-components"

export const StyledFrameWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 28px;
  padding: 20px;
  background: #ffffff;

  .cls-gradient-row {
    background: linear-gradient(180deg, #f0f0f0 0%, #adadad 100%);
    border-radius: 1px;
    width: 100%;
    height: 8px;
  }

  .fixture {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
    background: #e8e8e8;
    border-radius: 6px;
    min-height: 380px;
    min-width: 280px;
  }

  .fixture.gondola {
    border: none;
    background: #f6f6f6;
    box-shadow: 0px 0px 15.2px 3px rgba(0, 0, 0, 0.11);
    border-radius: 4px;
    padding: 4px;
    min-width: 320px;
  }

  .fixture.cooler {
    background: #f5f5f5;
    border: 5px solid #555555;
    border-radius: 8px;
    min-width: 220px;
  }

  .fixture.selected {
    border: 3px solid #2e9e44;
    background: #eef7ef;
  }

  .row {
    display: grid;
    flex: 1;
    min-height: 58px;
    border-bottom: 0px solid #c8c8c8;
    box-sizing: border-box;

    &:last-child {
      border-bottom: none;
    }
  }

  .row.head-row {
    border-bottom: 4px solid #555555;
    min-height: 44px;
    flex: 0 0 auto;
  }

  .row.foot-row {
    border-top: 0px solid #555555;
    border-bottom: none;
    min-height: 44px;
    flex: 0 0 auto;
  }

  .cell {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
    padding: 2px;
    box-sizing: border-box;
    border-right: 4px solid #c8c8c8;
    min-height: inherit;

    &:last-child {
      border-right: none;
    }
  }

  .cell.cell-device {
    justify-content: space-between;
    align-items: center;
    padding: 2px 8px;
    gap: 2px;
  }

  .cell.cell-dual-corner {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 2px;
  }

  .cell.corner-top-left {
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 2px;
  }

  .cell.corner-top-right {
    justify-content: flex-start;
    align-items: flex-end;
    padding-top: 2px;
  }

  .cell.corner-bottom-left {
    justify-content: flex-end;
    align-items: flex-start;
    padding-bottom: 2px;
  }

  .cell.corner-bottom-right {
    justify-content: flex-end;
    align-items: flex-end;
    padding-bottom: 2px;
  }

  .device-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 20px;
    padding: 2px 0;
  }

  .device-top.centered {
    justify-content: center;
    gap: 10px;
  }

  .camera-wrap {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
  }
  .camera-wrap-HCL,
  .camera-wrap-HCR {
    position: absolute;
    bottom: -24px;
  }
  // .camera-wrap-FCL,
  // .camera-wrap-FCR {
  //   position: absolute;
  //   bottom: 60px;
  // }
  .camera-wrap-HCR {
    right: 13px;
  }
  .camera-wrap-FCR {
    margin-right: 10px;
  }
  .camera-wrap-CM {
    position: relative;
    bottom: 5px;
    margin: 0 auto;
    width: fit-content;
  }
  .camera-icon {
    width: 18px;
    height: 18px;
    display: inline-flex;

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .shelf-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
    width: 137px;
    gap: 1px;
    // margin: auto;
  }

  .shelf-bar {
    width: fit-content;
    position: relative;
    bottom: -5px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin: auto;
  }

  .status-pin {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    line-height: 0;
  }

  .status-pin .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
  }

  .status-pin .stem {
    width: 1.5px;
    height: 6px;
    background: #666666;
    margin-top: -1px;
  }

  .status-pin-kit-CM {
    margin-left: 3px;
  }
  .status-pin-kit-SCM {
    position: absolute;
    bottom: 11px;
  }
  .status-pin.online .dot {
    background: #2ecc71;
  }

  .status-pin.offline .dot {
    background: #e74c3c;
  }

  .status-pin.flat {
    flex-direction: row;
    align-items: center;
  }

  .status-pin.flat .stem {
    width: 5px;
    height: 1.5px;
    margin-top: 0;
    margin-left: -1px;
  }

  .status-pin-kit-CM.status-pin.flat .stem {
    margin-left: -12px;
  }

  .status-pin-kit-HCL {
    margin-left: 5px;
    &.status-pin.flat .stem {
      margin-left: -12px;
    }
  }
  .status-pin-kit-FCL {
    margin-left: 5px;
    &.status-pin.flat .stem {
      margin-left: -12px;
    }
  }
  .no-head-c,
  .no-head-g {
    padding-top: 58px !important;
  }
  .no-foot-c,
  .no-foot-g {
    padding-bottom: 58px !important;
  }

  .no-head-c {
    border-bottom: 4px solid #555555 !important;
  }

  .gondola {
    .cell-device {
      border-right: 0px solid #c8c8c8 !important;
    }
  }
  .cooler {
    .head-row .cell {
      border-right: 0px solid #c8c8c8 !important;
    }
  }
`
